import React, { useContext, useEffect, useState, useCallback } from "react";
import styles from "../../css/DatabaseImport.module.css";
import useTheme from "../../config/useTheme";
import ModalShell from "components/shared/modal/ModalShell";
import ModalContext from "config/context/modalContext";
import { useImportMongoDatabase } from "api/database/useDatabase";
import { useNavigate } from "react-router-dom";
import SuccessfullActionModal from "features/permissions/components/modals/SuccessfullActionModal";
import AuthenticationContext from "config/context/authenticationContext";
import ProgressModal from "features/permissions/components/modals/ProgressModal";
import PrivateKeyField from "components/shared/private-key-field/PrivateKeyField";
const MongoImport = () => {
  const navigate = useNavigate();
  const { dark } = useTheme();
  const { isPermissionValid } = useContext(AuthenticationContext);
  const { handleModal } = useContext(ModalContext);

  const [data, setData] = useState({
    private_key: "",
    mongo_username: "",
    mongo_password: "",
    mongo_host: "127.0.0.1",
    mongo_port: "27017",
    mongo_database: "",
    mongo_collection: "",
    composition: "",
  });

  const {
    response,
    loading,
    error,
    importDatabase,
    resetServerStatus
  } = useImportMongoDatabase({
    private_key: data.private_key,
    mongo_username: data.mongo_username,
    mongo_password: data.mongo_password,
    mongo_host: data.mongo_host,
    mongo_port: data.mongo_port,
    mongo_database: data.mongo_database,
    mongo_collection: data.mongo_collection,
    composition: data.composition
  });

  const clearData = () => {
    setData((prevData) => ({
      ...prevData,
      mongo_username: "",
      mongo_password: "",
      mongo_host: "",
      mongo_port: "",
      mongo_database: "",
      mongo_collection: "",
      composition: "",
    }));
  };

  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    importDatabase();
  };

  useEffect(() => {
    if (!response?.status) return;
    
    setTimeout(() => {
      resetServerStatus();
      clearData();
      handleModal(false);
      navigate("/compositions?composition=" + response?.data?.compositions[0]?.name);
    }, 1600);
    
  }, [response]);

  if (loading) {
    return (
      <ModalShell>
        <ProgressModal loading={loading} />
      </ModalShell>
    );
  }

  if (response?.status) {
    return (
      <ModalShell>
        <SuccessfullActionModal message={response?.message} />
      </ModalShell>
    );
  }

  return (
    <ModalShell closeOnOverlay={true}>
      <div className={`${styles.modal} ${dark ? styles.dark : ''}`}>
        <div className={styles.modal_header}>
          <h2>Mongo Import</h2>
        </div>
        <form onSubmit={handleSubmit} className={styles.database_import_form}>
          {isPermissionValid('active') ? (
            ""
          ) : (
            <div className={styles.form_item}>
              <p>
                Private key <span>*</span>
              </p>
              <PrivateKeyField
                name="private_key"
                value={data.private_key}
                onChange={handleChange}
              />
            </div>
          )}
          <div className={styles.form_item}>
            <p>
              Mongo host <span>*</span>
            </p>
            <input
              type="text"
              name="mongo_host"
              value={data.mongo_host}
              onChange={handleChange}
            />
          </div>
          <div className={styles.form_item}>
            <p>
              Mongo port <span>*</span>
            </p>
            <input
              type="text"
              name="mongo_port"
              value={data.mongo_port}
              onChange={handleChange}
            />
          </div>
          <div className={styles.form_item}>
            <p>
              Mongo username <span>*</span>
            </p>
            <input
              type="text"
              name="mongo_username"
              value={data.mongo_username}
              onChange={handleChange}
            />
          </div>
          <div className={styles.form_item}>
            <p>
              Mongo password <span>*</span>
            </p>
            <input
              type="password"
              name="mongo_password"
              value={data.mongo_password}
              onChange={handleChange}
            />
          </div>
          <div className={styles.form_item}>
            <p>
              Mongo database <span>*</span>
            </p>
            <input
              type="text"
              name="mongo_database"
              value={data.mongo_database}
              onChange={handleChange}
            />
          </div>
          <div className={styles.form_item}>
            <p>
              Mongo collection <span>*</span>
            </p>
            <input
              type="text"
              name="mongo_collection"
              value={data.mongo_collection}
              onChange={handleChange}
            />
          </div>
          <div className={styles.form_item}>
            <p>
              Composition <span>*</span>
            </p>
            <input
              type="text"
              name="composition"
              value={data.composition}
              onChange={handleChange}
            />
          </div>
          {error && <div className={styles.error_area}>
            <p>{error}</p>
          </div>}
          <div className={styles.form_submition_area}>
            <>
              <button type="submit">Import</button>
              <button type="button" onClick={() => handleModal(false)}>
                Cancel
              </button>
            </>
          </div>
        </form>
      </div>
    </ModalShell>
  );
};

export default MongoImport;
